import React from 'react'
import { IconButton, Tooltip } from '@mui/material'

export interface CrosshairsControlProps {
  enabled?: boolean
  onToggle?: (enabled: boolean) => void
  disabled?: boolean
  theme?: 'dark' | 'light'
}

export const CrosshairsControl: React.FC<CrosshairsControlProps> = ({
  enabled = false,
  onToggle,
  disabled = false,
  theme = 'dark'
}) => {
  const handleToggle = () => {
    if (!disabled && onToggle) {
      onToggle(!enabled)
    }
  }

  return (
    <Tooltip title={enabled ? "Hide Crosshairs" : "Show Crosshairs"} placement="top">
      <IconButton
        size="small"
        onClick={handleToggle}
        disabled={disabled}
        sx={{
          width: '32px',
          height: '32px',
          border: '1px solid',
          borderColor: enabled 
            ? 'rgba(25, 118, 210, 0.8)' // Highlight when active
            : theme === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)',
          backgroundColor: enabled ? 'rgba(25, 118, 210, 0.8)' : 'transparent',
          color: enabled 
            ? 'white' 
            : theme === 'dark' ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.7)',
          borderRadius: '4px',
          '&:hover': {
            backgroundColor: enabled 
              ? 'rgba(25, 118, 210, 0.9)'
              : theme === 'dark' ? 'rgba(255, 255, 255, 0.04)' : 'rgba(0, 0, 0, 0.04)',
            borderColor: enabled
              ? 'rgba(25, 118, 210, 0.9)'
              : theme === 'dark' ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.3)'
          },
          '&.Mui-disabled': {
            opacity: 0.5,
            borderColor: theme === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)',
            color: theme === 'dark' ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.3)'
          }
        }}
      >
        {/* Custom crosshairs icon */}
        <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
          {/* Vertical line */}
          <line x1="8" y1="1" x2="8" y2="6" stroke="currentColor" strokeWidth="1.5" strokeDasharray="2,1" />
          <line x1="8" y1="10" x2="8" y2="15" stroke="currentColor" strokeWidth="1.5" strokeDasharray="2,1" />
          
          {/* Horizontal line */}
          <line x1="1" y1="8" x2="6" y2="8" stroke="currentColor" strokeWidth="1.5" strokeDasharray="2,1" />
          <line x1="10" y1="8" x2="15" y2="8" stroke="currentColor" strokeWidth="1.5" strokeDasharray="2,1" />
          
          {/* Center circle */}
          <circle cx="8" cy="8" r="1.5" fill="currentColor" />
        </svg>
      </IconButton>
    </Tooltip>
  )
} 